import React from 'react';
import { useTranslation } from 'react-i18next';
import { SectionFilter, SectionFilterTableData } from '../../../../store/sections/types';
import { DataTable, IconTrash } from '@skf/bt-wind-rail-commonlibrary';

import style from './SectionFilters.module.scss';
import { mapSectionFiltersToFilterDataArray } from '../../../../utils/mappers';

export interface SectionFilterTableProps {
  sectionFilters: SectionFilter[];
  onDeleteFilter: (filterToDelete: SectionFilter) => void;
}

export const SectionFiltersTable = ({
  sectionFilters,
  onDeleteFilter,
}: SectionFilterTableProps) => {
  const { t } = useTranslation();

  type RowType = {
    row: {
      original: SectionFilter;
    };
  };

  const sectionFiltersData: SectionFilterTableData[] = mapSectionFiltersToFilterDataArray(sectionFilters);

  const sectionTableColumns: any = [
    {
      Header: t('Section_Filters_SectionName'),
      accessor: 'webSectionFilterName',
      className: style.sectionTableColumn,
    },
    {
      Header: t('Section_Filters_PowerBITable'),
      accessor: 'webSectionFilterPowerBiTableName',
      className: style.sectionTableColumn,
    },
    {
      Header: t('Section_Filters_PowerBIField'),
      accessor: 'webSectionFilterPowerBiFieldName',
      className: style.sectionTableColumn,
    },
    {
      Header: t('Section_Filters_FilterType'),
      accessor: 'webSectionFilterTypeDescription',
      className: style.sectionTableColumn,
    },
    {
      Header: t('Section_Filters_SnowflakeTable'),
      accessor: 'webSectionSnowflakeTableName',
      className: style.sectionTableColumn,
    },
    {
      Header: t('Section_Filters_SnowflakeFields'),
      accessor: 'webSectionSnowflakeColumnName',
      className: style.sectionTableColumn,
    },
    {
      Header: t('Section_Filters_SingleSelect'),
      accessor: 'webSectionSingleSelectFlag',
      className: style.sectionTableColumn,
    },
    {
      Header: t('Section_Filters_Search'),
      accessor: 'webSectionSearchFlag',
      className: style.sectionTableColumn,
    },
    {
      Header: '',
      accessor: 'Action',
      disableSortBy: true,
      className: style.sectionTableColumnActions,
      Cell: ({ row }: RowType) => {
        const original = row.original;
        return (
          <div className={style.sectionFiltersTableDeleteIconContainer}>
            <IconTrash
              className={style.sectionFiltersTableDeleteIcon}
              onClick={() => {
                onDeleteFilter(original);
              }}
            />
          </div>
        );
      },
    },
  ];

  return (
    <DataTable
      columns={sectionTableColumns}
      data={sectionFiltersData}
      className={style.sectionFiltersTableContainer}
      pagination={20}
    />
  );
};
